import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { PHILOSOPHERS } from "../data/philosophers";
import Result from "./Result";

function hydrateResult(server) {
  const philById = (id) => PHILOSOPHERS.find((p) => p.id === id) || PHILOSOPHERS[0];
  return {
    user: server.traits,
    matches: server.ranking.map((m) => ({
      philosopher: philById(m.philosopher_id),
      r: m.r,
      pct: m.pct,
    })),
  };
}

export default function ResultLoader() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .getResult(id)
      .then((server) => {
        if (cancelled) return;
        setResult(hydrateResult(server));
        setError(null);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e?.response?.status || "unknown");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) {
    return (
      <div className="relative z-10 mx-auto min-h-[100dvh] max-w-md px-6 py-24 text-center">
        <p style={{ color: "var(--muted)" }}>Loading…</p>
      </div>
    );
  }
  if (error) {
    return (
      <div className="relative z-10 mx-auto min-h-[100dvh] max-w-md px-6 py-24 text-center">
        <p style={{ color: "var(--muted)" }}>Result not found.</p>
        <button className="btn-ghost mt-6" onClick={() => navigate("/")}>Back to home</button>
      </div>
    );
  }
  return <Result result={result} resultId={id} onRetake={() => navigate("/")} />;
}
